const connectionEventReducer = (state = {new_uievent: {}}, payload) => {
	switch(payload.type) {
		case 'CONNECTION_PUBLISH':
			return {...state, new_uievent: payload.event};
		default:
			return state;
	}
};

export default connectionEventReducer;